export default __webpack_public_path__ + "static/media/4bfa5c11dbd94b0f7a8ce78695f4ae99.svg";